import script from "./DatasetAnnouncementContent.vue?vue&type=script&setup=true&lang=js"
export * from "./DatasetAnnouncementContent.vue?vue&type=script&setup=true&lang=js"

import "./DatasetAnnouncementContent.vue?vue&type=style&index=0&id=5e274e1b&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-5e274e1b"]])

export default __exports__